module.exports = __webpack_public_path__ + "static/media/surveymonkey.877225ae.png";